import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhdsoftCommonService } from './services/phdsoft-common.service';
import { HeaderInterceptor, PhdsoftErrorService, RequestCache, RequestCacheWithMap, SharedModule, StorageService } from './shared';
import { AuthGuard } from './guard';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule.forRoot(),
    MatSnackBarModule
  ],
  providers: [
    PhdsoftCommonService,
    { provide: RequestCache, useClass: RequestCacheWithMap },
    //{ provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true
    },
    AuthGuard,
    StorageService,
    PhdsoftErrorService,
    provideHttpClient(withInterceptorsFromDi())
  ],
  exports: [
    SharedModule
  ]
})
export class PhdSoftCommonModule {

}
